import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SiteHeader } from "../../components/header/header";
import { faBroom } from "@fortawesome/free-solid-svg-icons";

import "../../styles/about.css";
import { cardsData } from "../../helpers/service-card-data";

export const AboutUs = () => {
    return (
        <div
            className="flx-col"
        >
            <SiteHeader title={"About Us"} />
            <div style={{ height: 100 }} />
            <div className="page-caption">Über uns</div>
            <div className="about-info">
                <p className="info-line">
                    Wir sind ein 2023 gegründetes, kundenfreundliches und zuverlässiges Reinigungsunternehmen, das Menschen gerne dabei hilft, saubere und komfortable Räume zu genießen.
                </p>
                <div className="covered">
                    Wir kümmern uns um alles, mit
                    <div className="service-list flx-col">
                        {cardsData.map((data, index) => (
                            <span 
                                key={index} 
                                className="list-item flx-rw c-al"
                            >
                                <FontAwesomeIcon icon={data.icon} />
                                <span className="list-label">{data.title}</span>
                            </span>
                        ))}
                    </div>
                </div>
                <p className="info-line rem">
                    "Wir achten auf jedes Detail und behandeln jedes Zuhause mit Sorgfalt, damit Sie sich entspannen und einen frischen, makellosen Raum genießen können."
                </p>
            </div>

        </div>
    )
}